"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShippingOfferItemSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _SelectedIcon = require("../shippingOffer/SelectedIcon");
var _sharedStyles = require("../shippingOffer/sharedStyles");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  ownerState: {
    isDoubleCurrency,
    opacity = 1
  },
  theme
}) => ({
  ...(0, _sharedStyles.itemStyles)(isDoubleCurrency, theme),
  opacity
}));
const Image = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  ...(0, _sharedStyles.imageStyles)(theme),
  opacity: 0.5
}));
const Description = (0, _mui.styled)('div')(({
  theme
}) => ({
  padding: theme.spacing(1, 2)
}));
const Text = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  borderRadius: theme.spacing(1),
  height: 21
}));
const TextWithSpacing = (0, _mui.styled)(Text)(({
  theme
}) => ({
  marginTop: theme.spacing(1)
}));
const ShippingOfferItemSkeleton = props => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    ownerState: props,
    ...getTestIdProps(_models.TestId.ShippingOfferItemSkeleton),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectedIcon.SelectedIcon, {
      isSelected: false
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Image, {
      animation: "wave",
      variant: "circular"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Description, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Text, {
        animation: "wave"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Text, {
        animation: "wave"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(TextWithSpacing, {
        animation: "wave",
        width: "50%"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(TextWithSpacing, {
        animation: "wave",
        width: "25%"
      })]
    })]
  });
};
exports.ShippingOfferItemSkeleton = ShippingOfferItemSkeleton;